import Lottie from "lottie-react";
import { playIcon } from "../../../../appAssets/jsons";
import { MagicPackItem } from "../../types";
import "./WallContent.scss";

interface WallContentProps {
  items: MagicPackItem[];
  isAudioView: boolean;
  onItemClick: (item: MagicPackItem) => void;
  isAudioType: boolean;
}

function WallContent({ items, onItemClick, isAudioType }: WallContentProps) {
  if (!items || items.length === 0) {
    return (
      <div className="wall-content__empty">
        <p>Nothing here yet — check back soon!</p>
      </div>
    );
  }

  const newItems = items.filter((i) => i.seen === false);
  const watchedItems = items.filter((i) => i.seen === true);

  const renderPlayButton = () => (
    <Lottie
      animationData={playIcon}
      loop
      autoplay
      style={{ width: 86, height: 86, flexShrink: 0, pointerEvents: "none" }}
    />
  );

  const renderItem = (item: MagicPackItem, idx: number) => (
    <button
      key={item.documentId ?? item.id ?? idx}
      type="button"
      className="wall-content__item"
      onClick={() => onItemClick(item)}
    >
      {item.coverImage ? (
        <div
          className="wall-content__cover"
          style={{ backgroundImage: `url(${item.coverImage})` }}
        >
          {item.title && (
            <span className="wall-content__title-badge">{item.title}</span>
          )}
          {renderPlayButton()}
        </div>
      ) : (
        <div className="wall-content__placeholder">
          <span className="wall-content__cloud">
            <span className="wall-content__cloud-text">DID YOU KNOW?</span>
          </span>
          <span className="wall-content__cloud-dot wall-content__cloud-dot--1" />
          <span className="wall-content__cloud-dot wall-content__cloud-dot--2" />
          <span className="wall-content__cloud-dot wall-content__cloud-dot--3" />
          {renderPlayButton()}
        </div>
      )}
    </button>
  );

  return (
    <div className="wall-content">
      {newItems.length > 0 && (
        <div className="wall-content__section">
          <h2 className="wall-content__section-title">
            New {isAudioType ? "Audio" : "Videos"}
          </h2>
          <div className="wall-content__grid">
            {newItems.map((item, idx) => renderItem(item, idx))}
          </div>
        </div>
      )}
      {watchedItems.length > 0 && (
        <div className="wall-content__section">
          <h2 className="wall-content__section-title">Watch again</h2>
          <div className="wall-content__grid wall-content__grid--watched">
            {watchedItems.map((item, idx) => renderItem(item, idx))}
          </div>
        </div>
      )}
    </div>
  );
}

export default WallContent;
